import { User, Info } from '@azing/user';
import { Lang } from '../lib/lang';

declare const float: any;
declare const floaters: any;

export function signedInEl(user: User, info: Info): HTMLElement {
  const userImageBtn = document.createElement('div');
  userImageBtn.innerHTML = `<img class="rounded-circle" src="https://azing.org/DnnImageHandler.ashx?mode=profilepic&h=45&w=45&userId=${user.id}" title="${(window as any).azing.getDisplayName(user)}">`;

  try {
    let loginFloater: any;
    loginFloater = float({
      attachTo: userImageBtn,
      template: getUserMenuContent(user, info, () => loginFloater.hide()),
      hasBackdrop: true,
      closeOnBackdropClick: true,
      backdropColor: 'transparent',
      positionStrategy: floaters.positionStrategies.ninja('BOTTOM_RIGHT', {
        x: 0,
        y: 16,
      }, true, false),
      customCss: `
              :host {
                  box-shadow: 0 1px 3px rgba(60,64,67, 0.3), 0 4px 8px 3px rgba(60,64,67, 0.15);
                  border-radius: 8px;
              }
          `,
      transition: () => 'bounce-top',
      arrowStrategy: floaters.arrowStrategies.topEnd(8, 21),
    });

    userImageBtn.addEventListener('click', () => {
      loginFloater.reposition();
      loginFloater.show();
    });

    window.addEventListener('scroll', () => {
      if (loginFloater) {
        loginFloater.hide();
      }
    });
  } catch (error) {
    console.error("floater error", error);
  }

  return userImageBtn;
}

function tasksEnabled() {
  const w = window as any;
  return w && w.azing && w.azing.userMenu && w.azing.userMenu.enableTasks;
}

function getUserMenuContent(user: User, info: Info, closeFloater: () => any): HTMLElement {
  const loc = Lang.getLanguagePack();
  const language = Lang.getUserLangSetting();
  const entries = {
    myRecipes: {
      label: loc.myRecipes, href: '', onClick: (ev: MouseEvent) => (
        ev.preventDefault(),
        ev.stopPropagation(),
        (window as any).azing.myRecipesChecklist()
      )
    },
    myProfile: { label: loc.myProfile, href: `/${language}/profile` },
    signOut: {
      label: loc.signOut, href: '', onClick: (ev: MouseEvent) => (
        ev.preventDefault(),
        ev.stopPropagation(),
        (window as any).azing.executeLogout()
      )
    },
    myTasks: { label: loc.myTasks, href: `/app/tasks/` },
    divider: { divider: true },
  } as { [key: string]: object };

  const menuEntries = [ entries.divider ] as any[];

  // first menu item is add task menu items
  if (tasksEnabled()) {
    menuEntries.push(
      entries.myTasks,
      entries.divider,
    );
  }

  //  current MyRecipes catalog
  menuEntries.push(entries.myRecipes);

  // append other Recipes catalogs menu items
  if (!!info && !!info.catalogs) {
    const otherRecipes = info.catalogs;
    otherRecipes.sort((a, b) => a.name > b.name ? 1 : -1);
    otherRecipes.forEach((item, index) => {
      menuEntries.push({ label: `${loc.otherRecipesMenuItem} ${item.name}`, href: `/${item.name}` });
    });
  }

  // other menu items
  menuEntries.push(
    entries.divider,
    entries.myProfile,
    entries.divider,
    entries.signOut,
  );

  const el = document.createElement('div');
  el.className = 'user-menu';
  el.innerHTML = `<div class="menu-title">${loc.signInAs} ${(window as any).azing.getDisplayName(user)}</div>`;
  menuEntries
    .map(({ divider, href, onClick, label }: any) => {
      if (divider) {
        const divider = document.createElement('div');
        divider.className = 'divider';
        return divider;
      }
      const entry = document.createElement('a');
      entry.className = 'menu-entry';
      if (onClick) {
        entry.addEventListener('click', (ev) => {
          onClick(ev);
          closeFloater();
        });
      }
      entry.className = 'menu-entry';
      entry.href = href;
      entry.innerHTML = label;
      return entry;
    })
    .forEach((entry) => el.appendChild(entry));
  return el;
}
